import PropTypes from 'prop-types';
import canonicalize from '../../../../services/canonicalize';

export const name = 'canonicalize';
export const propType = PropTypes.bool;
export const defaultProp = true;
export const onParse = s => canonicalize(s).content;
